import type { PopperProps } from '@mui/material/Popper';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

// Temporarily duplicates the shared table filter popper styling to keep menus
// consistent without exposing shared UI internals. Replace with a public shared
// column filter for equipment lists when one is available.
export const EquipmentFilterPopper = styled(
  (props: PopperProps) => <Popper {...props} placement="bottom-start" />,
  { name: 'EquipmentFilter', slot: 'Popper' }
)(({ theme }) => ({
  '.MuiAutocomplete-paper': {
    boxShadow: theme.shadows[4],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 250,
    maxWidth: 500,
  },
  '.MuiAutocomplete-option': {
    fontSize: theme.typography.body2.fontSize,
    whiteSpace: 'nowrap',
  },
}));
